import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

export function initMasonry() {
	const gridIds = ['#grid', '#gallery-grid'];

	gridIds.forEach(gridId => {
		const $grid = $(gridId);

		if (!$grid.length) return;

		var imgLoad = imagesLoaded(gridId);

		imgLoad.on('progress', function (image, elem, message) {
			//$grid.reloadItems();
			//console.log("Progress: " + message);
		});

		imgLoad.on('fail', function () {
			console.log('all images loaded, at least one is broken');
		});

		imgLoad.on('always', function (instance) {
			console.log("Always: " + instance);

			const masonry = new Masonry(gridId, {
				itemSelector: '.grid-item',
				percentPosition: true,
				columnWidth: '.grid-sizer',
				gutter: 25,
				transitionDuration: 0
			});
		});
	});
}


